var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "481px",
    height: "141px",
    viewBox: "0 0 481 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play Store Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 4,
    height: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 -6.66133815e-16 2.859375 -6.66133815e-16 2.859375 21.261719 0 21.261719"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 47 0 47 89 0 89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.648437,0.257812 C0.605468,1.335937 0,3.015625 0,5.195312 L0,82.878906 C0,85.054687 0.605468,86.738281 1.648437,87.820312 L1.90625,88.054687 L45.949218,44.542968 L45.949218,43.511718 L1.90625,0 L1.648437,0.257812 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.648437,0.257812 C0.605468,1.335937 0,3.015625 0,5.195312 L0,82.878906 C0,85.054687 0.605468,86.738281 1.648437,87.820312 L1.90625,88.054687 L45.949218,44.542968 L45.949218,43.511718 L1.90625,0",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.1982464%",
    y1: "82.0422508%",
    x2: "17.1980453%",
    y2: "33.1984818%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "6.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "6.64063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "7.03125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2FF",
    offset: "7.42188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2FF",
    offset: "7.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FF",
    offset: "8.20313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FF",
    offset: "8.59375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FF",
    offset: "8.98438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FF",
    offset: "9.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5FF",
    offset: "9.76563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5FF",
    offset: "10.1563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6FF",
    offset: "10.5469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6FF",
    offset: "10.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF",
    offset: "11.3281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF",
    offset: "11.7188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8FF",
    offset: "12.1094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8FF",
    offset: "12.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A9FF",
    offset: "12.8906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A9FF",
    offset: "13.2813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    offset: "13.6719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABFF",
    offset: "14.4531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABFF",
    offset: "14.8438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACFF",
    offset: "15.2344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACFF",
    offset: "15.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADFF",
    offset: "16.0156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF",
    offset: "16.4063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF",
    offset: "16.7969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "17.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "17.5781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0FF",
    offset: "17.9688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0FF",
    offset: "18.3594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF",
    offset: "18.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF",
    offset: "19.1406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF",
    offset: "19.5312%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF",
    offset: "19.9219%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF",
    offset: "20.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF",
    offset: "20.7031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4FF",
    offset: "21.0938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4FF",
    offset: "21.4844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B5FF",
    offset: "21.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B5FF",
    offset: "22.2656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6FF",
    offset: "22.6563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6FF",
    offset: "23.0469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7FF",
    offset: "23.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7FF",
    offset: "23.8281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8FF",
    offset: "24.2188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8FF",
    offset: "24.6094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "25.3906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAFF",
    offset: "25.7813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAFF",
    offset: "26.1719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBFF",
    offset: "26.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBFF",
    offset: "26.9531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCFF",
    offset: "27.3438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCFF",
    offset: "27.7344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDFF",
    offset: "28.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDFF",
    offset: "28.5156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "28.9063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "29.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFF",
    offset: "30.4687%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    offset: "31.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    offset: "32.0313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1FF",
    offset: "32.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF",
    offset: "33.5938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF",
    offset: "34.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C3FF",
    offset: "35.1563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4FF",
    offset: "35.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4FF",
    offset: "36.7188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF",
    offset: "37.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF",
    offset: "38.2813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "39.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "39.8438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8FF",
    offset: "40.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FF",
    offset: "41.4063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FF",
    offset: "42.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CAFF",
    offset: "42.9688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBFF",
    offset: "43.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBFF",
    offset: "44.5313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCFF",
    offset: "45.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CDFF",
    offset: "46.0938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CEFF",
    offset: "46.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CEFF",
    offset: "47.6563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF",
    offset: "48.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0FF",
    offset: "49.2188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF",
    offset: "50.7813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3FF",
    offset: "53.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3FF",
    offset: "54.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D5FF",
    offset: "57.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6FF",
    offset: "59.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D7FF",
    offset: "60.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8FF",
    offset: "62.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF",
    offset: "64.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DAFF",
    offset: "65.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "67.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DCFF",
    offset: "68.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DDFF",
    offset: "70.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF",
    offset: "71.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "73.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF",
    offset: "78.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF",
    offset: "81.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1FF",
    offset: "84.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1FF",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2FF",
    offset: "90.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "93.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-12",
    points: "0 0 38 0 38 31 0 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84217094e-14,14.511718 L2.84217094e-14,15.542968 L14.664063,30.050781 L15.011719,29.867187 L32.398438,20.105468 C37.359375,17.3125 37.359375,12.742187 32.398438,9.96875 L15.011719,0.191406 L14.683594,0 L2.84217094e-14,14.511718 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84217094e-14,14.511718 L2.84217094e-14,15.542968 L14.664063,30.050781 L15.011719,29.867187 L32.398438,20.105468 C37.359375,17.3125 37.359375,12.742187 32.398438,9.96875 L15.011719,0.191406 L14.683594,0",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.002272%",
    y1: "50.0034829%",
    x2: "0.000656146148%",
    y2: "50.0034936%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00",
    offset: "1.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00",
    offset: "3.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00",
    offset: "4.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00",
    offset: "6.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00",
    offset: "7.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB00",
    offset: "9.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB00",
    offset: "10.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA00",
    offset: "12.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA00",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD900",
    offset: "15.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800",
    offset: "17.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800",
    offset: "18.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700",
    offset: "20.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700",
    offset: "21.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600",
    offset: "23.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD500",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD500",
    offset: "26.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "28.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD400",
    offset: "29.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300",
    offset: "31.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300",
    offset: "32.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200",
    offset: "34.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100",
    offset: "35.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100",
    offset: "37.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000",
    offset: "39.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000",
    offset: "40.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00",
    offset: "42.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00",
    offset: "43.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE00",
    offset: "45.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    offset: "46.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    offset: "48.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    offset: "51.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB00",
    offset: "53.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA00",
    offset: "54.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA00",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900",
    offset: "57.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900",
    offset: "59.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800",
    offset: "60.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800",
    offset: "62.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700",
    offset: "64.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600",
    offset: "65.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600",
    offset: "67.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "68.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "70.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400",
    offset: "71.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC300",
    offset: "73.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC300",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    offset: "76.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    offset: "78.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC100",
    offset: "79.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC100",
    offset: "81.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC000",
    offset: "82.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00",
    offset: "84.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00",
    offset: "85.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE00",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE00",
    offset: "89.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "90.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00",
    offset: "93.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00",
    offset: "96.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0 0 60 0 60 46 0 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,43.789062 C1.648438,45.496093 4.335938,45.707031 7.390625,43.992187 L59.3125,14.835937 L44.300781,0 L0,43.789062 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,43.789062 C1.648438,45.496093 4.335938,45.707031 7.390625,43.992187 L59.3125,14.835937 L44.300781,0",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.9057944%",
    y1: "77.4445249%",
    x2: "21.9060578%",
    y2: "28.6025656%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "59.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "60.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3944",
    offset: "62.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3945",
    offset: "64.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3945",
    offset: "65.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC3845",
    offset: "67.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC3846",
    offset: "68.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB3746",
    offset: "70.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA3746",
    offset: "71.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA3647",
    offset: "73.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F93647",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F93647",
    offset: "76.5625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83548",
    offset: "78.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F73548",
    offset: "79.6875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F73448",
    offset: "81.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63448",
    offset: "82.8125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53349",
    offset: "84.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53349",
    offset: "85.9375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43349",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4324A",
    offset: "89.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3324A",
    offset: "90.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2314A",
    offset: "92.1875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2314B",
    offset: "93.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1314B",
    offset: "95.3125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1304B",
    offset: "96.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0304C",
    offset: "98.4375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2F4C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-26",
    points: "0 0 60 0 60 46 0 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.398437 L44.300781,45.171875 L59.3125,30.332031 L7.390625,1.171875 C5.960938,0.378906 4.609375,0 3.40625,0 C2.042969,0 0.875,0.484375 0,1.398437",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.398437 L44.300781,45.171875 L59.3125,30.332031 L7.390625,1.171875 C5.960938,0.378906 4.609375,0 3.40625,0 C2.042969,0 0.875,0.484375 0,1.398437",
    id: "path-30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "playStoreBadge",
    transform: "translate(0.539063, 0.125000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.023437,140.507813 L17.769531,140.507813 C8,140.507813 2.84217094e-14,132.601563 2.84217094e-14,122.945313 L2.84217094e-14,17.5625 C2.84217094e-14,7.90625 8,0 17.769531,0 L462.023437,0 C471.792968,0 479.796875,7.90625 479.796875,17.5625 L479.796875,122.945313 C479.796875,132.601563 471.792968,140.507813 462.023437,140.507813",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.023437,0 L17.769531,0 C8,0 2.84217094e-14,7.90625 2.84217094e-14,17.5625 L2.84217094e-14,122.945313 C2.84217094e-14,132.601563 8,140.507813 17.769531,140.507813 L462.023437,140.507813 C471.792968,140.507813 479.796875,132.601563 479.796875,122.945313 L479.796875,17.5625 C479.796875,7.90625 471.792968,0 462.023437,0 M462.023437,2.8125 C470.25,2.8125 476.945312,9.429688 476.945312,17.5625 L476.945312,122.945313 C476.945312,131.078125 470.25,137.695313 462.023437,137.695313 L17.769531,137.695313 C9.542968,137.695313 2.847656,131.078125 2.847656,122.945313 L2.847656,17.5625 C2.847656,9.429688 9.542968,2.8125 17.769531,2.8125 L462.023437,2.8125",
    id: "Shape",
    fill: "#A6A6A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.523437,35.984375 C168.523437,38.917969 167.632812,41.265625 165.886718,43.015625 C163.871093,45.09375 161.25,46.140625 158.039062,46.140625 C154.96875,46.140625 152.347656,45.074219 150.195312,42.980469 C148.042968,40.855469 146.964843,38.246094 146.964843,35.128906 C146.964843,32.003906 148.042968,29.398438 150.195312,27.289063 C152.347656,25.179688 154.96875,24.113281 158.039062,24.113281 C159.566406,24.113281 161.023437,24.425781 162.414062,25.007813 C163.800781,25.589844 164.929687,26.378906 165.746093,27.355469 L163.890625,29.207031 C162.464843,27.542969 160.523437,26.722656 158.039062,26.722656 C155.800781,26.722656 153.855468,27.496094 152.207031,29.054688 C150.578125,30.617188 149.761718,32.644531 149.761718,35.128906 C149.761718,37.613281 150.578125,39.65625 152.207031,41.214844 C153.855468,42.761719 155.800781,43.550781 158.039062,43.550781 C160.414062,43.550781 162.414062,42.761719 163.992187,41.199219 C165.027343,40.167969 165.621093,38.742188 165.777343,36.925781 L158.039062,36.925781 L158.039062,34.390625 L168.363281,34.390625 C168.484375,34.9375 168.523437,35.46875 168.523437,35.984375",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.523437,34.2695313 C168.523437,31.3359375 167.632812,28.9882813 165.886718,27.2382813 C163.871093,25.1601563 161.25,24.1132813 158.039062,24.1132813 C154.96875,24.1132813 152.347656,25.1796875 150.195312,27.2734375 C148.042968,29.3984375 146.964843,32.0078125 146.964843,35.125 C146.964843,38.25 148.042968,40.8554688 150.195312,42.9648438 C152.347656,45.0742188 154.96875,46.140625 158.039062,46.140625 C159.566406,46.140625 161.023437,45.828125 162.414062,45.2460938 C163.800781,44.6640625 164.929687,43.875 165.746093,42.8984375 L163.890625,41.046875 C162.464843,42.7109375 160.523437,43.53125 158.039062,43.53125 C155.800781,43.53125 153.855468,42.7578125 152.207031,41.1992188 C150.578125,39.6367188 149.761718,37.609375 149.761718,35.125 C149.761718,32.640625 150.578125,30.5976563 152.207031,29.0390625 C153.855468,27.4921875 155.800781,26.703125 158.039062,26.703125 C160.414062,26.703125 162.414062,27.4921875 163.992187,29.0546875 C165.027343,30.0859375 165.621093,31.5117188 165.777343,33.328125 L158.039062,33.328125 L158.039062,35.8632813 L168.363281,35.8632813 C168.484375,35.3164063 168.523437,34.7851563 168.523437,34.2695313 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(157.744140, 35.126953) scale(-1, 1) rotate(-180.000000) translate(-157.744140, -35.126953) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "184.902343 27.183594 175.203125 27.183594 175.203125 33.859375 183.949218 33.859375 183.949218 36.398438 175.203125 36.398438 175.203125 43.070313 184.902343 43.070313 184.902343 45.660156 172.460937 45.660156 172.460937 24.601563 184.902343 24.601563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(178.681640, 35.130859) scale(-1, 1) rotate(-180.000000) translate(-178.681640, -35.130859) ",
    points: "184.902343 43.078125 175.203125 43.078125 175.203125 36.4023438 183.949218 36.4023438 183.949218 33.8632813 175.203125 33.8632813 175.203125 27.1914063 184.902343 27.1914063 184.902343 24.6015625 172.460937 24.6015625 172.460937 45.6601563 184.902343 45.6601563"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "196.460937 45.660156 193.714843 45.660156 193.714843 27.183594 187.769531 27.183594 187.769531 24.601563 202.414062 24.601563 202.414062 27.183594 196.460937 27.183594"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(195.091796, 35.130859) scale(-1, 1) rotate(-180.000000) translate(-195.091796, -35.130859) ",
    points: "196.460937 24.6015625 193.714843 24.6015625 193.714843 43.078125 187.769531 43.078125 187.769531 45.6601563 202.414062 45.6601563 202.414062 43.078125 196.460937 43.078125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "surface9-Clipped",
    transform: "translate(212.460937, 23.875000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "surface9",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.468750, 0.628906)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    transform: "translate(1.455078, 10.626953) scale(-1, 1) rotate(-180.000000) translate(-1.455078, -10.626953) ",
    points: "0.0859375 0.0976565 2.8242188 0.0976565 2.8242188 21.1562503 0.0859375 21.1562503"
  })))), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "227.902343 45.660156 225.183593 45.660156 225.183593 27.183594 219.210937 27.183594 219.210937 24.601563 233.875 24.601563 233.875 27.183594 227.902343 27.183594"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(226.542968, 35.130859) scale(-1, 1) rotate(-180.000000) translate(-226.542968, -35.130859) ",
    points: "227.902343 24.6015625 225.183593 24.6015625 225.183593 43.078125 219.210937 43.078125 219.210937 45.6601563 233.875 45.6601563 233.875 43.078125 227.902343 43.078125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,41.183594 C249.582031,42.761719 251.503906,43.550781 253.796875,43.550781 C256.070312,43.550781 258.015625,42.761719 259.574218,41.183594 C261.152343,39.605469 261.953125,37.582031 261.953125,35.128906 C261.953125,32.675781 261.152343,30.648438 259.574218,29.074219 C258.015625,27.496094 256.070312,26.703125 253.796875,26.703125 C251.503906,26.703125 249.582031,27.496094 248,29.074219 C246.421875,30.648438 245.621093,32.675781 245.621093,35.128906 C245.621093,37.582031 246.421875,39.605469 248,41.183594 M261.605468,42.945313 C259.507812,45.078125 256.902343,46.140625 253.796875,46.140625 C250.675781,46.140625 248.070312,45.078125 245.96875,42.945313 C243.875,40.820313 242.828125,38.214844 242.828125,35.128906 C242.828125,32.039063 243.875,29.433594 245.96875,27.308594 C248.070312,25.179688 250.675781,24.117188 253.796875,24.117188 C256.886718,24.117188 259.488281,25.179688 261.589843,27.324219 C263.703125,29.46875 264.75,32.058594 264.75,35.128906 C264.75,38.214844 263.703125,40.820313 261.605468,42.945313",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,29.0742187 C249.582031,27.4960937 251.503906,26.7070312 253.796875,26.7070312 C256.070312,26.7070312 258.015625,27.4960937 259.574218,29.0742187 C261.152343,30.6523437 261.953125,32.6757812 261.953125,35.1289062 C261.953125,37.5820312 261.152343,39.609375 259.574218,41.1835937 C258.015625,42.7617187 256.070312,43.5546875 253.796875,43.5546875 C251.503906,43.5546875 249.582031,42.7617187 248,41.1835937 C246.421875,39.609375 245.621093,37.5820312 245.621093,35.1289062 C245.621093,32.6757812 246.421875,30.6523437 248,29.0742187 Z M261.605468,27.3125 C259.507812,25.1796875 256.902343,24.1171875 253.796875,24.1171875 C250.675781,24.1171875 248.070312,25.1796875 245.96875,27.3125 C243.875,29.4375 242.828125,32.0429687 242.828125,35.1289062 C242.828125,38.21875 243.875,40.8242187 245.96875,42.9492187 C248.070312,45.078125 250.675781,46.140625 253.796875,46.140625 C256.886718,46.140625 259.488281,45.078125 261.589843,42.9335937 C263.703125,40.7890625 264.75,38.1992187 264.75,35.1289062 C264.75,32.0429687 263.703125,29.4375 261.605468,27.3125 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(253.789062, 35.128906) scale(-1, 1) rotate(-180.000000) translate(-253.789062, -35.128906) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "268.597656 45.660156 268.597656 24.601563 271.933593 24.601563 282.292968 40.976563 282.410156 40.976563 282.292968 36.925781 282.292968 24.601563 285.03125 24.601563 285.03125 45.660156 282.171875 45.660156 271.324218 28.472656 271.203125 28.472656 271.324218 32.535156 271.324218 45.660156"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    transform: "translate(276.814453, 35.130859) scale(-1, 1) rotate(-180.000000) translate(-276.814453, -35.130859) ",
    points: "268.597656 24.6015625 268.597656 45.6601563 271.933593 45.6601563 282.292968 29.2851563 282.410156 29.2851563 282.292968 33.3359375 282.292968 45.6601563 285.03125 45.6601563 285.03125 24.6015625 282.171875 24.6015625 271.324218 41.7890625 271.203125 41.7890625 271.324218 37.7265625 271.324218 24.6015625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.046875,105.382813 L386.691406,105.382813 L386.691406,61.472656 L380.046875,61.472656 L380.046875,105.382813 Z M439.792968,77.289063 L432.175781,96.324219 L431.945312,96.324219 L424.070312,77.289063 L416.921875,77.289063 L428.757812,103.890625 L422.003906,118.6875 L428.929687,118.6875 L447.167968,77.289063 L439.792968,77.289063 Z M402.171875,100.390625 C400,100.390625 396.980468,99.328125 396.980468,96.671875 C396.980468,93.269531 400.746093,91.96875 404.007812,91.96875 C406.925781,91.96875 408.296875,92.601563 410.066406,93.445313 C409.546875,97.507813 406.003906,100.390625 402.171875,100.390625 M402.96875,76.324219 C398.179687,76.324219 393.199218,78.417969 391.152343,83.050781 L397.035156,85.488281 C398.296875,83.050781 400.628906,82.261719 403.085937,82.261719 C406.527343,82.261719 410.015625,84.300781 410.066406,87.90625 L410.066406,88.367188 C408.867187,87.683594 406.300781,86.667969 403.140625,86.667969 C396.804687,86.667969 390.351562,90.113281 390.351562,96.546875 C390.351562,102.433594 395.542968,106.21875 401.371093,106.21875 C405.832031,106.21875 408.296875,104.230469 409.84375,101.917969 L410.066406,101.917969 L410.066406,105.308594 L416.46875,105.308594 L416.46875,88.46875 C416.46875,80.679688 410.585937,76.324219 402.96875,76.324219 M361.996093,82.636719 L352.554687,82.636719 L352.554687,67.578125 L361.996093,67.578125 C366.941406,67.578125 369.769531,71.640625 369.769531,75.105469 C369.769531,78.503906 366.941406,82.636719 361.996093,82.636719 M361.820312,61.472656 L345.925781,61.472656 L345.925781,105.382813 L352.554687,105.382813 L352.554687,88.746094 L361.820312,88.746094 C369.183593,88.746094 376.402343,83.480469 376.402343,75.105469 C376.402343,66.738281 369.164062,61.472656 361.820312,61.472656 M275.171875,100.40625 C270.59375,100.40625 266.761718,96.617188 266.761718,91.402344 C266.761718,86.132813 270.59375,82.292969 275.171875,82.292969 C279.6875,82.292969 283.246093,86.132813 283.246093,91.402344 C283.246093,96.617188 279.6875,100.40625 275.171875,100.40625 M282.777343,79.738281 L282.550781,79.738281 C281.058593,77.992188 278.214843,76.410156 274.605468,76.410156 C267.035156,76.410156 260.117187,82.980469 260.117187,91.402344 C260.117187,99.773438 267.035156,106.289063 274.605468,106.289063 C278.214843,106.289063 281.058593,104.695313 282.550781,102.894531 L282.777343,102.894531 L282.777343,105.039063 C282.777343,110.753906 279.6875,113.820313 274.710937,113.820313 C270.648437,113.820313 268.128906,110.921875 267.089843,108.484375 L261.308593,110.871094 C262.976562,114.832031 267.386718,119.703125 274.710937,119.703125 C282.5,119.703125 289.074218,115.175781 289.074218,104.144531 L289.074218,77.320313 L282.777343,77.320313 L282.777343,79.738281 Z M293.660156,105.382813 L300.308593,105.382813 L300.308593,61.472656 L293.660156,61.472656 L293.660156,105.382813 Z M310.09375,90.886719 C309.921875,85.128906 314.621093,82.175781 317.988281,82.175781 C320.625,82.175781 322.867187,83.480469 323.609375,85.34375 L310.09375,90.886719 Z M330.707031,85.914063 C329.457031,82.570313 325.609375,76.410156 317.761718,76.410156 C309.984375,76.410156 303.515625,82.464844 303.515625,91.351563 C303.515625,99.722656 309.921875,106.289063 318.507812,106.289063 C325.453125,106.289063 329.457031,102.105469 331.105468,99.667969 L325.953125,96.277344 C324.234375,98.757813 321.890625,100.40625 318.507812,100.40625 C315.144531,100.40625 312.730468,98.882813 311.1875,95.878906 L331.402343,87.613281 L330.703125,85.914063 L330.707031,85.914063 Z M169.683593,80.988281 L169.683593,87.339844 L185.023437,87.339844 C184.570312,90.886719 183.375,93.496094 181.535156,95.3125 C179.296875,97.507813 175.808593,99.945313 169.683593,99.945313 C160.242187,99.945313 152.847656,92.414063 152.847656,83.085938 C152.847656,73.753906 160.242187,66.222656 169.683593,66.222656 C174.785156,66.222656 178.503906,68.195313 181.242187,70.75 L185.769531,66.277344 C181.933593,62.660156 176.832031,59.878906 169.683593,59.878906 C156.738281,59.878906 145.859375,70.289063 145.859375,83.085938 C145.859375,95.878906 156.738281,106.289063 169.683593,106.289063 C176.675781,106.289063 181.933593,104.023438 186.066406,99.773438 C190.300781,95.589844 191.617187,89.703125 191.617187,84.953125 C191.617187,83.480469 191.492187,82.121094 191.273437,80.988281 L169.683593,80.988281 Z M209.0625,100.40625 C204.476562,100.40625 200.523437,96.671875 200.523437,91.351563 C200.523437,85.964844 204.476562,82.292969 209.0625,82.292969 C213.644531,82.292969 217.582031,85.964844 217.582031,91.351563 C217.582031,96.671875 213.644531,100.40625 209.0625,100.40625 M209.0625,76.410156 C200.695312,76.410156 193.894531,82.6875 193.894531,91.351563 C193.894531,99.945313 200.695312,106.289063 209.0625,106.289063 C217.421875,106.289063 224.226562,99.945313 224.226562,91.351563 C224.226562,82.6875 217.421875,76.410156 209.0625,76.410156 M242.152343,100.40625 C237.570312,100.40625 233.632812,96.671875 233.632812,91.351563 C233.632812,85.964844 237.570312,82.292969 242.152343,82.292969 C246.734375,82.292969 250.691406,85.964844 250.691406,91.351563 C250.691406,96.671875 246.734375,100.40625 242.152343,100.40625 M242.152343,76.410156 C233.804687,76.410156 226.988281,82.6875 226.988281,91.351563 C226.988281,99.945313 233.804687,106.289063 242.152343,106.289063 C250.515625,106.289063 257.339843,99.945313 257.339843,91.351563 C257.339843,82.6875 250.515625,76.410156 242.152343,76.410156",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(34.460937, 25.875000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.976563, 0.351563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "90.496093 44.027343 22.976562 110.761718 -44.542969 44.027343 22.976562 -22.707032"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(80.460937, 54.875000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.925781, 0.351563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-18)",
    fillRule: "nonzero",
    mask: "url(#mask-17)",
    points: "37.359375 0 37.359375 30.050781 2.84217094e-14 30.050781 2.84217094e-14 0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.460937, 69.875000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.625000, 0.382813)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-25)",
    fillRule: "nonzero",
    mask: "url(#mask-24)",
    points: "82.433594 22.851562 29.65625 75.015625 -23.125 22.851562 29.65625 -29.3125"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.460937, 24.875000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.625000, 0.210938)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00F076",
    fillRule: "nonzero",
    mask: "url(#mask-31)",
    points: "29.65625 74.480468 -22.851562 22.585937 29.65625 -29.308594 82.160156 22.585937"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreBadge);
export default __webpack_public_path__ + "static/media/playStoreBadge.b1bd8f8d44a9e80c0a469bf7a67a24f8.svg";
export { ForwardRef as ReactComponent };